import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import VideoItem from './Items/VideoItem';
import TourItem from './Items/TourItem';
import RenderItem from './Items/RenderItem';

const Carousel = ({ items, settings }) => {
  const drawContent = (content) => {
    console.log(`drawContent called, content: ${ content}`);
    switch (content.type) {
      case 'video':
      case 'video-ia':
        return (<VideoItem src={content.src} />);
      case 'panoramic':
      case 'orbit':
      case 'solar-simulator':
        return (<TourItem src={content.src} />);
      case 'render':
      case 'render-ia':
      default:
        return (<RenderItem src={content.src} />);
    }
  };

  const onInit = () => {
    console.log('josep onInit');
  };

  const onReInit = () => {
    console.log('josep onReInit');
  };

  const beforeChange = (current, next) => {
    console.log(`josep before change, current: ${current}, next: ${next}`);
  };

  const afterChange = (current) => {
    console.log(`josep after change, current: ${current}`);
  };

  const callbacks = {
    beforeChange: (current, next) => beforeChange(current, next),
    afterChange: current => afterChange(current),
    onInit: () => onInit(),
    onReInit: () => onReInit(),
  };

  return (
    <Slider {...settings} {...callbacks}>
      {
        items.map(content => drawContent(content))
      }
    </Slider>
  );
};

Carousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    type: PropTypes.string,
    alt: PropTypes.string,
  })).isRequired,

  settings: PropTypes.node.isRequired,

};

export default Carousel;
